"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _analyticsAndCommerceScripts = require("../analyticsAndCommerceScripts");
var _isSalesmanagoEnabled = _interopRequireDefault(require("../isSalesmanagoEnabled"));
var _isNewsletterEnabled = _interopRequireDefault(require("../isNewsletterEnabled"));
var addFacebookPixel = function addFacebookPixel(src) {
  var facebookPixel = document.createElement("img");
  facebookPixel.setAttribute("width", "1px");
  facebookPixel.setAttribute("height", "1px");
  facebookPixel.setAttribute("src", src);
  var footer = document.getElementById("footer");
  if (footer) {
    footer.appendChild(facebookPixel);
  } else {
    document.body.appendChild(facebookPixel);
  }
};
var addTurnstileDialog = function addTurnstileDialog(label, key) {
  var turnstileDiv = document.createElement("dialog");
  var closeButton = document.createElement("div");
  var dialogLabel = document.createElement("span");
  turnstileDiv.setAttribute("class", "cf-turnstile");
  turnstileDiv.setAttribute("data-sitekey", key);
  turnstileDiv.setAttribute("data-callback", "javascriptCallback");
  dialogLabel.innerText = label;
  turnstileDiv.appendChild(closeButton);
  turnstileDiv.appendChild(dialogLabel);
  document.body.appendChild(turnstileDiv);
};
var addGTMNoScript = function addGTMNoScript(gtmID) {
  var noScript = document.createElement("noscript");
  var iframe = document.createElement("iframe");
  iframe.setAttribute("width", "1px");
  iframe.setAttribute("height", "1px");
  iframe.setAttribute("style", "display:none;visibility:hidden;");
  iframe.setAttribute("src", (0, _analyticsAndCommerceScripts.gtmNoscriptSrc)(gtmID));
  noScript.appendChild(iframe);
  document.body.appendChild(noScript);
};
var loadScript = function loadScript(script, src) {
  var defer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var tag = document.createElement("script");
  tag.setAttribute("async", "true");
  tag.setAttribute("type", "text/javascript");
  if (defer) {
    tag.setAttribute("defer", "true");
  }
  if (script) {
    tag.innerHTML = script;
  }
  if (src) {
    tag.setAttribute("src", src);
  }
  document.body.appendChild(tag);
};
var addSalesmanago = function addSalesmanago(language) {
  return (0, _isNewsletterEnabled["default"])({
    language: language
  }) || (0, _isSalesmanagoEnabled["default"])({
    language: language
  });
};
var addAnalyticsAndCommerceScripts = function addAnalyticsAndCommerceScripts(currentLanguage, cookieAgreements, ids) {
  var scripts = [];
  var srcs = [];
  var cfToken = sessionStorage.getItem("cfToken");
  var turnstileEnabled = Boolean(parseInt(global.__appConfig__.turnstileConfig[currentLanguage].enabled)) && !cfToken;
  if (addSalesmanago(currentLanguage) && cookieAgreements.salesmanago) {
    scripts.push((0, _analyticsAndCommerceScripts.salesmanago)(global.__appConfig__.salesmanagoID));
  }
  if (cookieAgreements.gtm) {
    srcs.push((0, _analyticsAndCommerceScripts.gtmSrc)(ids.analyticsID));
    scripts.push((0, _analyticsAndCommerceScripts.ga4Script)(ids.analyticsID));
    addGTMNoScript(ids.gtmID);
  }
  if (cookieAgreements.pixelFb) {
    if (global.__appConfig__.facebookEnabled) {
      scripts.push((0, _analyticsAndCommerceScripts.facebookScript)(ids.fbID));
      addFacebookPixel((0, _analyticsAndCommerceScripts.facebookSrc)(ids.fbID));
    }
  }
  turnstileEnabled && addTurnstileDialog(global.__appConfig__.turnstileConfig[currentLanguage].label, global.__appConfig__.turnstileConfig[currentLanguage].siteKey);
  if (turnstileEnabled) {
    scripts.push((0, _analyticsAndCommerceScripts.turnstile)());
    loadScript(false, global.__appConfig__.turnstileScriptUrl, true);
  }
  scripts.map(function (script) {
    return loadScript(script);
  });
  srcs.map(function (src) {
    return loadScript(false, src);
  });
};
var _default = addAnalyticsAndCommerceScripts;
exports["default"] = _default;